import { FormGroup } from '@angular/forms';
import { Numbers } from 'src/app/utils/constants';

export default class StudentsStepOneExtended {

  /**
   * constructor
   */
  constructor(
    ) {
  }

  public isFieldI = false;
  public hideGuaranteeTable = false;

  /**
   * countryDestiny
   * @param insureSelected string
   */
  countryDestiny(insureSelected: string): void {
    if (insureSelected === '') {
      this.isFieldI = true;
    } else {
      this.isFieldI = false;
    }
  }

  /**
   * getGreaterScopeUtils
   * @param selectA selectA
   * @param listA listA
   * @returns returns
   */
  getGreaterScopeUtils(selectA: number, listA: any): number {
    listA.forEach((item: any) => {
      if (selectA === Numbers.number19004 || item === Numbers.number19004) {
        selectA = Numbers.number19004;
      } else {
        if (item > selectA) {
          selectA = item;
        }
      }
    });
    return selectA;
  }

  /**
   * checkShowGuaranteeTableUtils
   * @param formData formData
   */
    checkShowGuaranteeTableUtils(formData: FormGroup, insureSelected: string): void {
      // tslint:disable-next-line: radix
      if (parseInt(formData.get([insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.name, Numbers.number10) ===
          Numbers.number18000) {
        this.hideGuaranteeTable = true;
      } else {
        this.hideGuaranteeTable = false;
      }
    }
}
